module.exports = __webpack_public_path__ + "static/media/123.07d8d41b.png";